import {COMMON, CONSTANT} from "../../common.js";

const BID = (function () {
    let modules = {};

    return modules;
})(window.jQuery, window, document);

$(document).ready(function () {
    $(document).on('change', '#form-search-bids .select-sort', function () {
        $('#form-search-bids .btn-search').trigger('click');
    })
});